import React, { useRef } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { TileInspector } from "../../../mapEditor/TileInspector";
import { selectorMapEditorStore } from "../../../../stores/MapEditorStore";
import { LoadingSpinner } from "../../../shared/LoadingSpinner";
import { useTranslation } from "react-i18next";
import { ActionMapContainer } from "./ActionMapContainer";
import { ActionMapViewerSelectorPopup } from "./ActionMapViewerSelectorPopup";
const SpinnerContainer = styled.div.withConfig({
  displayName: "ActionMapViewProvider__SpinnerContainer",
  componentId: "sc-1mgwuux-0"
})(["display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%;"]);
export const ActionMapViewProvider = observer(({
  selectedMapElements,
  selectElement
}) => {
  const {
    t
  } = useTranslation();
  const canvasContainerRef = useRef();
  const {
    currentMapStore
  } = selectorMapEditorStore;

  if (currentMapStore.runningMapOperation) {
    return /*#__PURE__*/React.createElement(SpinnerContainer, null, /*#__PURE__*/React.createElement(LoadingSpinner, null), t("game.map_loading"));
  }

  const {
    hasCurrentMap
  } = currentMapStore;
  if (!hasCurrentMap) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    ref: canvasContainerRef
  }), /*#__PURE__*/React.createElement(ActionMapContainer, null), /*#__PURE__*/React.createElement(TileInspector, {
    mapEditorStore: selectorMapEditorStore,
    hideEditorTileInspector: true
  }), /*#__PURE__*/React.createElement(ActionMapViewerSelectorPopup, {
    selectedMapElements: selectedMapElements,
    selectElement: selectElement,
    canvasContainerRef: canvasContainerRef
  }));
});